import { render, staticRenderFns } from "./inav.vue?vue&type=template&id=37b5b31e"
import script from "./inav.vue?vue&type=script&lang=js"
export * from "./inav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports